<template>
    <!-- 外链Iframe -->
    <div class="iframeWrap" v-if="iframeData.isshow">
     <div class="ifrmaeMenu">
         <p @click="closeIframe" ><返回</p>
         <p>{{iframeData[iframeData.nowIndex].name}}</p>
     </div>
      <div class="iframebox">
        <iframe :src="iframeData[iframeData.nowIndex].url" frameborder="0" scroll="no"></iframe>
      </div>
    </div>
    <!-- 外链Iframe -->
</template>

<style type="text/css">
.iframeWrap{ width: 100%; height: 102vh; position: fixed; top:0; left:0; overflow-y: scroll; z-index:9999999999999999; }
.ifrmaeMenu{      width: 100%;
    height: 8vh;
    background-color: #fff;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    color: #2d2d2d;
    padding: 0 0.2rem;
    font-size: 0.30rem;
    border-bottom: 0.01rem solid #dadada;
    cursor: pointer;}
    .ifrmaeMenu p:nth-child(1){ color: #e61b1b;}
.iframebox iframe{ width: 100%; height: 94vh; background-color: #fff }
</style>
<script type="text/javascript">
	export default{
		name:'iframebox',
		props:['iframeData'],
		data(){
			return {
        isshowIframe:true,
			}
		},
		mounted (){
			
		},
		methods:{
			closeIframe(e){
        if(vrComponents.iframeData.state=="replayGame"){
          //window.location.reload();
          vrComponents.setReplayData();
          return false;
        }
        this.iframeData.isshow=!this.iframeData.isshow
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/iframebox.vue